import IntegrationCallResourceModel from '../../generated/types/model/resource/IntegrationCallResourceModel';

export default class IntegrationCallResourceViewModel extends IntegrationCallResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
